export enum EidEasySigningMethod {
	SMART_ID = 'smart-id',
	FTN = 'ftn',
	DRAW = 'draw',
	OTP = 'otp',
	SE_BANKID = 'se-bankid',
	NORWEGIAN_BANKID = 'no-bankid',
	MITID = 'mitid',
	FREJA = 'freja',
}

/**
 * Methods that sign a detached CAdES digest which is then embedded into the PDF
 * via PAdES, rather than signing the `pdf` container directly. Smart-ID uses
 * this flow; Norwegian BankID uses it because its direct-PDF variant requires
 * the signer's name (the hash variant needs none). Everything else (FTN, OTP,
 * DRAW/handwritten, Swedish BankID, MitID, Freja) signs the PDF directly.
 */
const HASH_FLOW_METHODS: ReadonlySet<EidEasySigningMethod> = new Set([
	EidEasySigningMethod.SMART_ID,
	EidEasySigningMethod.NORWEGIAN_BANKID,
]);

/** Whether the method uses the detached-hash (CAdES → PAdES) signing flow. */
export const usesHashFlow = (method: EidEasySigningMethod): boolean =>
	HASH_FLOW_METHODS.has(method);

/**
 * Distinguishes how a `EidEasySigningMethod.DRAW` signature image was
 * produced on the client. `canvas` = genuinely hand-drawn on a signature pad
 * (preserve as PNG); `typed` = the signer typed their name and the client
 * rendered it in a script font (do not persist — re-typeset at cert time).
 */
export enum DrawnSignatureSource {
	CANVAS = 'canvas',
	TYPED = 'typed',
}
